import { NIDO_THEME_STORAGE_KEY } from './useTheme.js';

const STORAGE_KEY = NIDO_THEME_STORAGE_KEY;

function applyInitialTheme() {
    if (typeof document === 'undefined') return;
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        if (stored === 'dark') {
            document.documentElement.setAttribute('data-theme', 'dark');
            return;
        }
        if (stored === 'light') {
            document.documentElement.removeAttribute('data-theme');
            return;
        }
    } catch (e) {
        // sin storage: caer al sistema operativo
    }
    if (window.matchMedia?.('(prefers-color-scheme: dark)').matches) {
        document.documentElement.setAttribute('data-theme', 'dark');
    }
}

applyInitialTheme();
